import { Card, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import type { MiniStat } from "./types";

type Props = {
	stat: MiniStat;
};

export const MiniStatCard = ({ stat }: Props) => {
	const theme = useAppTheme();

	return (
		<Card
			mode="outlined"
			style={{
				borderRadius: theme.roundness * 2,
				borderColor: theme.colors.outlineVariant,
				flex: 1,
			}}
		>
			<Card.Content style={{ padding: 13, flex: 1 }}>
				<Box gap={32} flex={1} justifyContent="space-between">
					<Box gap={12}>
						<AppIcon
							name={stat.iconName}
							size={20}
							color={theme.colors.onSurfaceVariant}
						/>
						<Text
							variant="labelMedium"
							style={{
								color: theme.colors.onSurfaceVariant,
								letterSpacing: 0.3,
								textTransform: "uppercase",
							}}
						>
							{stat.label}
						</Text>
					</Box>
					{stat.value ? (
						<Box
							flexDirection="row"
							alignItems="baseline"
							gap={4}
							flexWrap="wrap"
						>
							<Text variant="bodyLarge" style={{ fontWeight: "600" }}>
								{stat.value}
							</Text>
							<Text
								variant="bodySmall"
								style={{ color: theme.colors.onSurfaceVariant }}
							>
								{stat.statusText}
							</Text>
						</Box>
					) : (
						<Box flex={1} minHeight={24} justifyContent="flex-end">
							<Text
								variant="bodySmall"
								style={{
									color: theme.colors.onSurfaceVariant,
								}}
							>
								{stat.statusText}
							</Text>
						</Box>
					)}
				</Box>
			</Card.Content>
		</Card>
	);
};
